import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import Button from 'nood-comp/src/comp/button/Button';
import Feedback from 'nood-comp/src/comp/feedback/Feedback';
import Form from 'nood-comp/src/comp/form/Form';
import TextField from 'nood-comp/src/comp/form/textfield/TextField';
import { __post, _get } from "nood-comp/src/net/xhr";
import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import { AuthContext } from "src/session/AuthProvider";
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import CenteredColumnWidth from "nood-comp/src/comp/ui/containers/CenteredColumnWidth";
import Text from "nood-comp/src/comp/text/Text";
import LogoSvg from "nood-comp/src/common/LogoSvg";
import FlexCenter from "nood-comp/src/comp/ui/containers/flex-boxes/FlexCenter";
import { Store } from "nood-comp/src/util/local-storage/Store";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import { useIAppContext } from "nood-comp/src/context-providers/IAppContextProvider";
import * as stylex from "@stylexjs/stylex";
import { styling } from "nood-comp/src/styles/styles.stylex";
export default function AdminLoginPage(props) {
  var _useIAppContext, _useIAppContext2;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    e = _useState2[0],
    setE = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    s = _useState4[0],
    setS = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    obj = _useState6[0],
    set_obj = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    valid = _useState8[0],
    set_valid = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    processing = _useState0[0],
    set_processing = _useState0[1];
  var navigate = useNavigate();
  var auth = useContext(AuthContext);
  var location = useLocation();
  var isDarkMode = ((_useIAppContext = useIAppContext()) === null || _useIAppContext === void 0 ? void 0 : _useIAppContext.lightOrDark) === 'dark';
  var setUserTheme = (_useIAppContext2 = useIAppContext()) === null || _useIAppContext2 === void 0 ? void 0 : _useIAppContext2.setUserTheme;
  useDocumentTitle(msg.title('Login'));
  function __login() {
    if (valid && !processing) {
      set_processing(true);
      __post('/admin.php', {
        body: JSON.stringify(obj),
        base_url: process.env.AUTH
      }, function (r) {
        var _r$http;
        set_processing(false);
        setE(r.error);
        setS(r.success);
        if (((_r$http = r.http) === null || _r$http === void 0 ? void 0 : _r$http.code) === 200) {
          _get('/adminuser', function (res) {
            var _res$http;
            if (((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 401) {
              auth.setUser(null); // this will show the AdminLoginPage.js
            } else {
              if (res.data) {
                auth.setUser(res.data);
                navigate("".concat(location.pathname).concat(location.search));
              }
            }
          });
          /*SessionManager.validate({
           endpoint: `${process.env.AUTH}/admin/validate.php`,
           callback: isValid => {
           if (isValid) {
           auth.setUser(r.data.user);
           navigate(`${location.pathname}${location.search}`);
           }
           }
           })*/
        }
      });
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(FlexCenter, null, /*#__PURE__*/React.createElement(LogoSvg, {
    size: 40,
    accent: "#e34a7f"
  })), /*#__PURE__*/React.createElement("div", stylex.props(styling.web_only), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  })), /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 350,
    style: {
      backgroundColor: "var(--shade-05)",
      border: "1px solid var(--shade-10)",
      padding: 30,
      borderRadius: "var(--more-roundness)"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: 20
  }, "Admin Login"), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  }), /*#__PURE__*/React.createElement(Feedback, {
    errors: e,
    success: s
  }), /*#__PURE__*/React.createElement(Spacer, {
    mbottom: 20
  }), /*#__PURE__*/React.createElement(Form, {
    __setter: set_obj,
    __validSetter: set_valid,
    __submit: function __submit(obj, err) {
      __login();
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    icon: "user",
    name: 'username',
    placeholder: 'Username',
    validations: ['required'],
    spacer: 10
  }), /*#__PURE__*/React.createElement(TextField, {
    icon: "key",
    name: 'password',
    placeholder: 'Password',
    validations: ['required'],
    password: true,
    spacer: 25
  }), /*#__PURE__*/React.createElement(Button, {
    loading: processing,
    disabled: !valid || processing,
    label: 'Login',
    primary: true,
    rightIcon: "arrow-right"
  }))), /*#__PURE__*/React.createElement("div", stylex.props(styling.web_only), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  })), /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 350,
    containerStylex: [ui.no_spacing]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "var(--shade-10)",
      width: 35,
      height: 35,
      cursor: "pointer",
      padding: 10,
      borderRadius: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    onClick: function onClick() {
      var finalMode = isDarkMode ? 'light' : 'dark';
      setUserTheme(finalMode);
      Store.save('user-theme', finalMode);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: isDarkMode ? 'sun' : 'moon'
  })))));
}

// @ts-ignore
_inject(".ev1717udv{padding:0}", 1000);
_inject("@media (max-width: 599px){.ev1i0qtz1.ev1i0qtz1{width:100%}}", 4200);
_inject("@media (max-width: 599px){.ev180n2cw.ev180n2cw{padding:0}}", 1200);
var ui = {
  no_spacing: {
    "AdminLoginPage__ui.no_spacing": "AdminLoginPage__ui.no_spacing",
    padding: "ev1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    "@media (max-width: 599px)_width": "ev1i0qtz1",
    "@media (max-width: 599px)_padding": "ev180n2cw",
    "@media (max-width: 599px)_paddingInline": null,
    "@media (max-width: 599px)_paddingStart": null,
    "@media (max-width: 599px)_paddingLeft": null,
    "@media (max-width: 599px)_paddingEnd": null,
    "@media (max-width: 599px)_paddingRight": null,
    "@media (max-width: 599px)_paddingBlock": null,
    "@media (max-width: 599px)_paddingTop": null,
    "@media (max-width: 599px)_paddingBottom": null,
    $$css: true
  }
};